module.exports = __webpack_public_path__ + "img/close.5933978b.svg";